import React from 'react';
import { FilterOption } from './filter-option';
import {
  FilterType,
  FilterUISubPlacementEnum,
  IFilter,
} from 'src/components/price-list/types';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { useAppContext } from '@prisjakt/ui-app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import { FilterPanel, FilterRow } from '../styles';

type AllFiltersProps = {
  filters: IFilter[];
  onToggleFilter: (e: FilterType) => void;
};

export const AllFilters = ({ filters, onToggleFilter }: AllFiltersProps) => {
  const { t } = useAppContext();
  const { getTranslatedLabel } = useOfferListFilterContext();
  const onProductTypeFilterChanged = (filterType: FilterType) => {
    onToggleFilter(filterType);
  };

  const getFilters = (filteredFilters: IFilter[]) =>
    filteredFilters
      .filter(filter => !!filter.hidden)
      .map(filter => {
        const label = getTranslatedLabel(t, filter.type);
        let isChecked = filter.active;
        if (filter.additive) {
          isChecked = !filter.active;
        }
        return (
          <FilterOption
            key={label}
            optionId={label}
            filterType={filter.type}
            defaultValue={isChecked}
            onChange={onProductTypeFilterChanged}
            label={label}
          />
        );
      });

  const renderFilters = () => {
    const showOnlyFilters = getFilters(
      filters.filter(
        filter => filter.subPlacement === FilterUISubPlacementEnum.SHOW_ONLY
      )
    );

    const additiveFilters = getFilters(
      filters.filter(
        filter => filter.subPlacement === FilterUISubPlacementEnum.ADDITIVE
      )
    );

    return (
      <div>
        <FilterRow>
          <TitleMediumText>{t('filter', 'label.show-only')}</TitleMediumText>
          {showOnlyFilters}
        </FilterRow>
        {additiveFilters.length > 0 && (
          <FilterRow>
            <TitleMediumText>{t('filter', 'label.add')}</TitleMediumText>
            {additiveFilters}
          </FilterRow>
        )}
      </div>
    );
  };

  return (
    <FilterPanel data-testid="FilterOptions">{renderFilters()}</FilterPanel>
  );
};
